import * as types from '../mutations-types'
import {createActionHelpers} from 'vuex-loading'

import { getCurrentDateTime } from '../../utils/api'
const {startLoading} = createActionHelpers({
  moduleName: 'loading'
})

// STATES
const state = {
  currentDateTime: ''
}

// GETTERS
const getters = {
  currentDateTime: state => state.currentDateTime
}

// ACTIONS
const actions = {
  getCurrentDateTime({ dispatch, commit }) {
    return new Promise(async(resolve, reject) => {
      try {
        const response = await startLoading(dispatch, 'gettingCurrentDateTime', () => {
          return getCurrentDateTime()
        })
        commit(types.SET_CURRENT_DATE_TIME, response.data.datetime)
        resolve()
      } catch (error) {
        console.error('ERROR GCDT', error)
        reject(error)
      }
    })
  }
}

// MUTATIONS
const mutations = {
  [types.SET_CURRENT_DATE_TIME](state, value) {
    state.currentDateTime = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/currentDateTime.js